import { render, staticRenderFns } from "./ReturnFilters.vue?vue&type=template&id=99d256b6"
import script from "./ReturnFilters.vue?vue&type=script&lang=js"
export * from "./ReturnFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports